<div class="main">
  <div class="container">
    <div class="assigned-attributes-header">Assigned Attributes</div>
    <div>
      <button
        mat-icon-button
        matTooltip="Edit Assigned Attributes"
        (click)="editAssignedAttributes()"
        [disabled]="!canEdit">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>

  <div class="assigned-attributes-content">
    <ul class="assigned-attributes-list">
      @for (attribute of assignedAttributes; track attribute) {
        <li>
          {{ attribute.name }}
        </li>
      }
    </ul>
  </div>

  <form [formGroup]="form" novalidate (ngSubmit)="submit()">
    <div class="consumer-type-content">
      <mat-form-field appearance="fill"   class="flex-align-center flex-55">
        <mat-select
          placeholder="Consumer Type"
          required
          formControlName="destinationType"
          >
          @for (consumerType of (consumerTypes$ | async); track consumerType) {
            <mat-option
              [value]="consumerType.tag"
              >
              {{ consumerType.name }}
            </mat-option>
          }
        </mat-select>
        @if (form.controls['destinationType'].invalid) {
          <mat-error>
            Please select a Consumer Type
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div>
      <mat-form-field appearance="fill"   class="flex-align-center flex-55">
        <mat-label>Consumer Description</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="3"

          required
          placeholder="Please enter a description"
          formControlName="description" class="flex-100"
        ></textarea>
        @if (form.controls['description'].invalid) {
          <mat-error>Please enter a Name</mat-error>
        }
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="fill"   class="flex-align-center flex-55">
        <mat-select
          placeholder="Sales Channels"
          multiple
          formControlName="salesChannels">
          @for (channel of salesChannels; track channel) {
            <mat-option
              [value]="channel.tag"
              [disabled]="true">
              {{ channel.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</div>
